import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';

const RESOURCE = '/users/role/:roleId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    roleId: string;
}
const mutationFn = ({ roleId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { roleId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteRole };
